module.exports = __webpack_public_path__ + "static/img/200172.292bb256.png";